import React from 'react'
import { FileObject, FilePurpose, FileType } from '@citruscamps/citrus-client'
import { useFetchFiles } from '../hooks/useFetchFiles'
import { ImagePicker } from './ImagePicker'

interface IProps {
  value?: FileObject
  programId: string
  filetypes?: FileType[]
  purposes?: FilePurpose[]
  onSelect?: (file?: FileObject) => void | Promise<void>
}

export const MediaLibraryView = ({
  value,
  programId,
  filetypes,
  purposes,
  onSelect: handleSelect,
}: IProps) => {
  const { data, isLoading, pagination, search, setPagination, setSearch } = useFetchFiles({
    programId,
    fetchProps: {
      sort: 'created',
      order: 'DESC',
      filter: {
        purpose: purposes,
        filetype: filetypes,
      },
    },
  })
  return (
    <div className="mt-3">
      <div className="mx-3 mb-2">
        <input
          className="form-control rounded"
          placeholder="Search for files"
          value={search || ''}
          onChange={(evt: any) => {
            setSearch(evt.target.value)
          }}
        />
      </div>
      <ImagePicker
        value={value}
        images={data}
        loading={isLoading}
        pagination={pagination}
        onChangePage={setPagination}
        onSelect={handleSelect}
      />
    </div>
  )
}
